module.exports = __webpack_public_path__ + "img/ser-img2.b5b8dd43.png";